import { useLocalStorageState } from 'ahooks';

export interface PastPromptItem {
  id: string;
  prompt: string;
  created_at: string;
}

export const usePastePrompt = () => {
  const [pastePrompt, setPastePrompt] = useLocalStorageState<PastPromptItem[]>('pastePromptList', {
    defaultValue: [],
    listenStorageChange: true,
  });

  const sortedPastePrompt = pastePrompt?.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()) ?? [];

  const addPastePrompt = (prompt: string) => {
    if (prompt) {
      setPastePrompt([
        {
          id: String(new Date().getTime()),
          prompt,
          created_at: new Date().toISOString(),
        },
        ...(pastePrompt as PastPromptItem[]).slice(-99),
      ]);
    }
  };

  return {
    pastePrompt: sortedPastePrompt,
    setPastePrompt,
    addPastePrompt,
  };
};
